import type React from 'react';
import { useTranslation } from 'react-i18next';
import DownloadRounded from '@mui/icons-material/DownloadRounded';
import { LoadingButton } from '@mui/lab';

import { useDownloadClickHandler } from 'src/components/dashboard/hooks/index';

export interface ResponseManagerDownloadButtonProps {
  widgetId: number;
}

const ResponseManagerDownloadButton: React.FC<
  ResponseManagerDownloadButtonProps
> = ({ widgetId }) => {
  const { t } = useTranslation('common');
  const { loading, handleDownloadClick } = useDownloadClickHandler(widgetId);

  return (
    <LoadingButton
      // TODO: use LanguageChooser when i18n gets activated again
      onClick={(event) => {
        event.stopPropagation();
        handleDownloadClick();
      }}
      loading={loading}
      startIcon={<DownloadRounded />}
      variant="cta"
    >
      {t('download')}
    </LoadingButton>
  );
};

export default ResponseManagerDownloadButton;
